import classNames from "classnames";
import Avatar from "../../common/Avatar";
import { actions } from "../../../data/chat";
import MessageActionButtons from "./MessageActionButtons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";

const Message = ({ message, user, showActions = true }) => {
  const isSent = message.type === "sent";
  const isReceived = message.type === "received" || message.type === "reply";

  return (
    <div className="d-flex chat-message">
      <div
        className={classNames("d-flex flex-1", {
          "justify-content-end": isSent,
        })}
      >
        <div
          className={classNames("w-100", {
            "w-xxl-75": showActions,
          })}
        >
          <div
            className={classNames("d-flex hover-actions-trigger", {
              "flex-end-center": isSent,
            })}
          >
            {isReceived && (
              <Avatar
                src={user?.avatar}
                size="m"
                className="me-3 flex-shrink-0 p-1 white-chat-bg rounded-circle"
              />
            )}

            {isSent && showActions && (
              <MessageActionButtons actions={actions} variant="sent" />
            )}

            <div
              className={classNames("chat-message-content me-2", {
                received: isReceived,
              })}
            >
              <div
                className={classNames("mb-1", {
                  "sent-message-content": isSent,
                  "received-message-content border border-translucent":
                    isReceived,
                })}
              >
                {message.message &&
                  (isSent ? (
                    <p className="mb-0">{message.message}</p>
                  ) : (
                    <div
                      className="mb-0 chat-bot-html-content"
                      dangerouslySetInnerHTML={{ __html: message.message }}
                    />
                  ))}
              </div>
            </div>
            {isReceived && showActions && (
              <MessageActionButtons
                actions={actions.slice(1)}
                variant="received"
              />
            )}
          </div>
          <div
            className={classNames("d-flex gap-1 fs-10", {
              "ms-7": isReceived,
              "justify-content-end": isSent,
            })}
          >
            <p className="mb-0 text-body-tertiary text-opacity-85 fw-medium">
              {message.time}
            </p>
            {message.readAt && (
              <FontAwesomeIcon icon={faCheckDouble} className="text-success" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Message;
